interface Props {
  KeyFeature: {
    Title: string;
    Description: string;
    Icon: {
      PublicURL: string;
    };
  };
}

const KeyFeature = ({ KeyFeature }: Props) => {
  return (
    <div
      style={{
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
      }}
      className=" tw:w-2xs tw:border-gray-200 tw:rounded-md tw:p-2 tw:my-2 tw:flex tw:items-center"
    >
      <div className="tw:flex tw:items-center">
        {KeyFeature.Icon.PublicURL && (
          <img
            className="tw:w-10 tw:h-10 tw:rounded tw:mr-2"
            src={KeyFeature.Icon.PublicURL}
            alt="Feature Image"
          />
        )}
        <div className="tw:ml-2">
          <p className="tw:text-sm tw:font-bold tw:p-0 tw:m-0">
            {KeyFeature.Title}
          </p>
          <p className="tw:text-xs tw:p-0 tw:m-0"> {KeyFeature.Description}</p>
        </div>
      </div>
    </div>
  );
};

export default KeyFeature;
